import type { PageDimensions } from '../layout/types';

export type PageId = number;

export type GetEffectiveDimensions = (
  pageId: PageId,
  baseDimensions: PageDimensions
) => PageDimensions;

export const identityDimensions: GetEffectiveDimensions = (_, dims) => dims;

/**
 * State-aware variant of GetEffectiveDimensions.
 * Produces a GetEffectiveDimensions from a given state object,
 * allowing proxy-memoize to track which state properties are read.
 */
export type GetEffectiveDimensionsFactory<TState = unknown> = (
  state: TState
) => GetEffectiveDimensions;
